import { calculate_total_price } from "@myproject/shared";
import { LuShoppingCart } from "react-icons/lu";

export const TotalPrice = ({orders, openBasket, placeOrder}) => {

const total_price = calculate_total_price(orders);
const formattedPrice = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2
}).format(total_price);

  return (
    <>

<div className="p-4">
<div className="h-auto bg-red flex justify-start mb-2">
    <div className="flex items-center h-5">

        <input
                  type="checkbox"
                  id="voorwaarden"
                  className="w-4 h-4 border border-white rounded bg-white focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                />
                </div>
                <label htmlFor="voorwaarden" className="ms-2 text-sm font-medium text-white dark:text-gray-300">
                  Ik ben akkoord met de <a href="#" className="text-white hover:underline underline dark:text-blue-500">voorwaarden</a>
                </label>
                </div>

      <div className="flex justify-between items-start">
        <div className="flex flex-col justify-between gap-0">
          <span className="text-3xl md:text-4xl font-extrabold text-white">{formattedPrice}</span>
          <span className="text-white text-sm font-medium">Incl 21% BTW</span>
        </div>
        <div className="flex gap-2">

        <button
        onClick={openBasket}
        type="button"
        className="border-white relative border border-2  inline-flex items-center p-3 text-sm font-medium text-center text-white bg-blue-600 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        <LuShoppingCart className="text-white font-black" />
        <span className="sr-only">Notifications</span>
        <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-amber-600 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">
          {orders.length}
        </div>
      </button>

          <button
          onClick={placeOrder}
            type="button"
            className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 border-white border-white border border-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Bestellen
          </button>
        </div>
      </div>
      </div>
    </>
  );
};
